module.exports = {
      id: "gears-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#gears",
      toString: function () {
        return this.url;
      }
    }